import { properDate } from '../dateUtilities.js';

const getStageFromPipeline = (pipelines, pipelineLead) => {
  let pipeline = (pipelines || []).find((n) => n.id === pipelineLead.pipeline_id) || {};
  return (pipeline.stages || []).find((n) => n.id === pipelineLead.stage_id);
};

const generateLeadMeta = (leadId, leadMeta) => {
  let generatedMeta = { ...leadMeta };

  let syncPlatforms = generatedMeta.sync_platforms || [];
  for (let i = 0; i < syncPlatforms.length; i++) {
    let integration = syncPlatforms[i];
    if (!integration.platform_code) continue;
    let key = `last_outgoing_${integration.platform_code}_date`;
    generatedMeta[key] = {
      id: integration.platform_registrations_sync_leads_id,
      lead_id: leadId,
      pipeline_lead_id: null,
      type: key,
      value: integration.last_sync_datetime,
      singular: '1',
      integration: true,
      creation_datetime: integration.last_sync_datetime,
      modification_datetime: integration.last_sync_datetime,
    };
  }
  return generatedMeta;
};

const getActionType = (str = '') => {
  return (str === 'burst') ? 'burst' : str.split('.')[0];
};

const cookPipelineLead = (pipelineLead, pipelines) => {
  const stage = getStageFromPipeline(pipelines, pipelineLead);

  let lastStageUpdate = (pipelineLead.meta || {}).last_stage_update_date || { value: pipelineLead.creation_datetime };
  let lastStageUpdateDate = new Date(properDate(lastStageUpdate.value)).getTime();

  let stageAltActions = [
    ...((stage || {}).actions || [])
      .filter((el) => ['next', 'milestone'].includes(el.action_type))
      .map((n) => {
        let properties;
        if(typeof n.action_properties === "string") {
          try {
            properties = JSON.parse(n.action_properties)
          } catch {}
        }
        return ({ ...n, properties })
      })
  ];

  let stageActions = [
    ...((stage || {}).actions || [])
      .filter((el) => !['next', 'milestone'].includes(el.action_type))
      .map((n) => ({ ...n, action_order: parseFloat(n.action_order) }))
      .sort((a, b) => a.action_order - b.action_order),
  ];

  let actionsMeta = {};

  let nextStageAction = ((stage || {}).actions || []).find((el) => el.action_type === 'next');
  let nextMilestoneAction = ((stage || {}).actions || []).find((el) => el.action_type === 'milestone');

  if (nextStageAction !== undefined) {
    pipelineLead.next_stage_overdue = (new Date().getTime() - lastStageUpdateDate) / 1000 / 60 > Number(nextStageAction.wait_minutes);
  }

  if (nextMilestoneAction !== undefined) {
    pipelineLead.next_milestone_overdue = (new Date().getTime() - lastStageUpdateDate) / 1000 / 60 > Number(nextMilestoneAction.wait_minutes);
  }

  for (let i = 0; i < stageActions.length; i++) {
    let type = getActionType(stageActions[i].action_type);
    let metaKey = stageActions[i].action_type === "burst" ? type : `last_outgoing_${type}_date`;
    let leadMeta = generateLeadMeta(pipelineLead.lead_id, (pipelineLead.computed || {}).leadMeta);
    let leadMetaItem = leadMeta[metaKey];
    if (!leadMetaItem && type === 'reviewloop') {
      leadMetaItem = leadMeta['last_reviewloop_sent_date'];
    }
    if (actionsMeta[type] === undefined) {
      actionsMeta[type] = {
        eventDate: leadMetaItem !== undefined ? new Date(properDate(leadMetaItem.value)).getTime() : null,
        count: 1,
        burst: stageActions[i].burst,
        integration: !!(leadMetaItem || {}).integration,
        currentCount: 0,
      };
    } else {
      actionsMeta[type].count += 1;
    }
  }

  for (let i = 0; i < stageActions.length; i++) {
    if(stageActions[i].action_type === "burst"){
      continue;
    }
    let action = { ...stageActions[i] };
    let actionMeta = actionsMeta[getActionType(action.action_type)] || {};
    let prevAction = stageActions[i - 1] || {};
    let prevActionMeta = actionsMeta[getActionType(prevAction.action_type)] || {};
    actionMeta.currentCount += 1;

    if (actionMeta.eventDate >= lastStageUpdateDate) {
      if (actionMeta.count === 1 || i === 0) {
        action.status = 'completed';
      } else {
        if (actionMeta.currentCount <= actionMeta.count) {
          if (prevActionMeta && (prevActionMeta.eventDate === null || prevActionMeta.eventDate > actionMeta.eventDate || prevAction.status === 'pending')) {
            action.status = 'pending';
          } else {
            action.status = 'completed';
          }
        }
      }
    }

    if (actionMeta.eventDate < lastStageUpdateDate) {
      action.status = 'pending';
    }

    if (action.status !== 'completed' && action.wait_minutes !== null && (prevAction || {}).status === 'completed') {
      if ((new Date().getTime() - (prevActionMeta || {}).eventDate) / 1000 / 60 > Number(action.wait_minutes)) {
        action.status = 'overdue';
      }
    }
    if (i === 0 && action.status === 'pending' && (new Date().getTime() - lastStageUpdateDate) / 1000 / 60 > Number(action.wait_minutes)) {
      action.status = 'overdue';
    }
    if (actionMeta.integration) {
      action.status = 'completed';
    }
    stageActions[i] = action;
  }

  pipelineLead.actionsMeta = actionsMeta;
  pipelineLead.actions = stageActions;
  pipelineLead.alt_actions = stageAltActions;

  return { ...pipelineLead };
};

export default cookPipelineLead;
